/* Set builder helpers (US): one-time set discount code; jump to the Add button after the last step; sizes chosen on
   the card on phones; "Skipped" marks; phone bottom bar (hides near the full set block, lifts above pinned bars,
   --mt-bb-clear for the chat button); desktop "Your set" frame with a pinned Add button; return to the top of the
   next step; the set in progress is kept for the browser tab (sessionStorage) and rebuilt after a reload. */
(function () {
  'use strict';
  var API = 'https://discounts.markenda.space/api/generate.php';

  function isSet(items) {
    return Array.isArray(items) && items.length > 1 &&
      items.every(function (i) { return i && i.properties && i.properties._mt_set; });
  }
  function timeout(ms) { return new Promise(function (res) { setTimeout(function () { res(null); }, ms); }); }
  function getCode(items) {
    var ids = items.map(function (i) { return i.id; });
    var req = fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ variant_ids: ids }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && d.success && d.code ? String(d.code) : null; })
      .catch(function () { return null; });
    return Promise.race([req, timeout(8000)]);
  }
  function prepare(items) {
    return getCode(items).then(function (code) {
      if (!code) return items;
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {})
        .then(function () {
          return items.map(function (i) {
            var p = {};
            for (var k in i.properties) { if (Object.prototype.hasOwnProperty.call(i.properties, k)) p[k] = i.properties[k]; }
            p._Bundle = code;
            return { id: i.id, quantity: i.quantity, properties: p };
          });
        });
    });
  }
  function wrap() {
    if (!window.MT || !window.MT.cartAdd) return false;
    if (window.MT.cartAdd.__mtCodes) return true;
    var orig = window.MT.cartAdd;
    var wrapped = function (items) {
      var self = this, args = arguments;
      if (!isSet(items)) return orig.apply(self, args);
      return prepare(items).then(function (ready) { return orig.call(self, ready); });
    };
    wrapped.__mtCodes = true;
    window.MT.cartAdd = wrapped;
    return true;
  }
  function visibleCta(section) {
    var list = section.querySelectorAll('[data-mt-bb-add]');
    for (var i = 0; i < list.length; i++) { if (list[i].getClientRects().length) return list[i]; }
    return null;
  }
  function finishStep(section) {
    var cta = visibleCta(section);
    if (!cta) return;
    var r = cta.getBoundingClientRect();
    var inView = r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!inView) cta.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    var frame = cta.closest('.mt-bb__set');
    if (frame && frame.scrollHeight > frame.clientHeight + 4) frame.scrollTo({ top: frame.scrollHeight, behavior: calm ? 'auto' : 'smooth' });
    if (cta.disabled) return;
    cta.classList.remove('mt-bb-ready');
    void cta.offsetWidth;
    cta.classList.add('mt-bb-ready');
    setTimeout(function () { cta.classList.remove('mt-bb-ready'); }, 2600);
  }
  function onLastStep(section) {
    var label = section.querySelector('[data-mt-bb-steplabel]');
    if (!label) return false;
    var parts = label.textContent.replace(/[^0-9/]/g, '').split('/');
    return parts.length === 2 && parts[0] !== '' && parts[0] === parts[1];
  }
  var PHONE = '(max-width: 989px)';
  var skipped = {};
  var restoring = false;
  function stepIndex(section) {
    var label = section.querySelector('[data-mt-bb-steplabel]');
    if (!label) return -1;
    var n = parseInt(label.textContent.replace(/[^0-9/]/g, '').split('/')[0], 10);
    return isNaN(n) ? -1 : n - 1;
  }
  function markSkipped(section) {
    var box = section.querySelector('[data-mt-bb-tiles]');
    if (!box) return;
    var tiles = box.querySelectorAll('[data-mt-bb-tile]');
    var anyFilled = box.querySelector('.mt-filled');
    if (!anyFilled && stepIndex(section) === 0 && !restoring) skipped = {};
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i], idx = parseInt(t.getAttribute('data-mt-bb-tile'), 10);
      if (t.classList.contains('mt-filled')) { delete skipped[idx]; continue; }
      var on = !!skipped[idx], has = t.classList.contains('mt-bb-skipped');
      if (on && !has) {
        t.classList.add('mt-bb-skipped');
        var holder = t.querySelector('.mt-bb__tile-empty');
        if (holder && !holder.querySelector('.mt-bb-skiptag')) {
          var tag = document.createElement('span');
          tag.className = 'mt-bb-skiptag';
          tag.textContent = 'Skipped';
          holder.appendChild(tag);
        }
      }
    }
  }
  function stepTop(section) {
    var head = section.querySelector('.mt-bb__step-head');
    if (!head) return;
    var r = head.getBoundingClientRect();
    if (r.top >= 96 && r.top <= window.innerHeight * 0.5) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - 120), behavior: calm ? 'auto' : 'smooth' });
  }
  function lastStepWatch(section) {
    section.addEventListener('click', function (e) {
      if (restoring || !e.target.closest) return;
      var phone = window.matchMedia(PHONE).matches;
      /* on phones the photo is not a button for the size sheet */
      if (phone && e.target.closest('.mt-bb__card-media[data-mt-bb-open]')) { e.stopPropagation(); e.preventDefault(); return; }
      if (e.target.closest('[data-mt-bb-gender]')) { skipped = {}; return; }
      var t = e.target.closest('[data-mt-bb-select], [data-mt-bb-sheet-add], [data-mt-bb-skip], [data-mt-bb-open]');
      if (!t) return;
      var last = onLastStep(section);
      if (t.hasAttribute('data-mt-bb-skip')) { var idx = stepIndex(section); if (idx > -1) skipped[idx] = true; setTimeout(function () { markSkipped(section); }, 60); }
      if (!last) { if (!phone) setTimeout(function () { stepTop(section); }, 140); return; }
      var sheet = section.querySelector('[data-mt-bb-sheet]');
      setTimeout(function () { if (!sheet || sheet.hidden) finishStep(section); }, 150);
    }, true);
    var box = section.querySelector('[data-mt-bb-tiles]');
    if (box && window.MutationObserver) new MutationObserver(function () { markSkipped(section); showLatest(section, box); }).observe(box, { childList: true });
  }
  function showLatest(section, box) {
    var frame = box.closest('.mt-bb__set');
    if (!frame || frame.scrollHeight <= frame.clientHeight + 4) return;
    var filled = box.querySelectorAll('.mt-filled');
    var last = filled[filled.length - 1];
    if (!last) { frame.scrollTop = 0; return; }
    var fr = frame.getBoundingClientRect(), lr = last.getBoundingClientRect();
    var room = fr.bottom - 96;
    if (lr.bottom > room) frame.scrollTop += lr.bottom - room;
    else if (lr.top < fr.top + 56) frame.scrollTop -= (fr.top + 56 - lr.top);
  }
  function phoneBar(section) {
    var bar = section.querySelector('.mt-bb__bar');
    var sideCta = section.querySelector('.mt-bb__side [data-mt-bb-add]');
    if (!bar) return;
    if (sideCta && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        section.classList.toggle('mt-bb-sumview', entries[0].isIntersecting);
        setTimeout(lift, 50);
      }, { threshold: 0.6 }).observe(sideCta);
    }
    function isPinned(el) {
      for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
        if (getComputedStyle(n).position === 'fixed') return true;
      }
      return false;
    }
    function lift() {
      if (!window.matchMedia(PHONE).matches || !document.elementsFromPoint) { section.style.removeProperty('--mt-bb-lift'); return; }
      var vw = window.innerWidth, vh = window.innerHeight, top = vh;
      var hits = document.elementsFromPoint(vw / 2, vh - 3).concat(document.elementsFromPoint(vw / 4, vh - 3));
      for (var i = 0; i < hits.length; i++) {
        var el = hits[i];
        if (section.contains(el) || el === document.body || el === document.documentElement) continue;
        if (!isPinned(el)) continue;
        var r = el.getBoundingClientRect();
        if (r.width < vw * 0.6 || r.height > vh * 0.4 || r.bottom < vh - 2) continue;
        if (r.top < top) top = r.top;
      }
      var px = Math.max(0, Math.round(vh - top));
      if (px > 0) section.style.setProperty('--mt-bb-lift', px + 'px');
      else section.style.removeProperty('--mt-bb-lift');
      clearance(px);
    }
    function clearance(px) {
      var shown = getComputedStyle(bar).display !== 'none';
      var h = shown ? Math.round(bar.getBoundingClientRect().height) + (px || 0) : 0;
      document.documentElement.style.setProperty('--mt-bb-clear', h + 'px');
    }
    [0, 600, 1500, 3000, 6000, 10000].forEach(function (ms) { setTimeout(lift, ms); });
    window.addEventListener('resize', lift);
    section.addEventListener('click', function () { setTimeout(lift, 300); });
  }
  function deskFrame(section) {
    var frame = section.querySelector('.mt-bb__set');
    if (!frame) return;
    var raf = 0;
    function fit() {
      raf = 0;
      if (window.matchMedia(PHONE).matches) { frame.style.maxHeight = ''; return; }
      var top = frame.getBoundingClientRect().top;
      var h = window.innerHeight - Math.max(top, 96) - 16;
      frame.style.maxHeight = Math.max(h, 150) + 'px';
    }
    function ask() { if (!raf) raf = window.requestAnimationFrame(fit); }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    section.addEventListener('click', function () { setTimeout(fit, 200); });
    fit();
    setTimeout(fit, 800);
  }
  function persist(section) {
    var KEY = 'mtbb:' + window.location.pathname;
    var state = { gender: null, step: 0, picks: {} };
    function store() { try { return window.sessionStorage; } catch (e) { return null; } }
    function write() {
      if (restoring || !store()) return;
      var g = section.querySelector('[data-mt-bb-gender].mt-on');
      state.gender = g ? g.getAttribute('data-mt-bb-gender') : null;
      state.step = Math.max(0, stepIndex(section));
      state.skipped = skipped;
      try { store().setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }
    function byData(attr, pid, value, onOnly) {
      var list = section.querySelectorAll('[' + attr + ']');
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (pid !== null && el.getAttribute('data-pid') !== String(pid)) continue;
        if (value !== null && el.getAttribute(attr) !== String(value)) continue;
        if (onOnly && !el.classList.contains('mt-on')) continue;
        return el;
      }
      return null;
    }
    section.addEventListener('click', function (e) {
      if (restoring || !e.target.closest) return;
      var t;
      if (e.target.closest('[data-mt-bb-gender]')) { state.picks = {}; setTimeout(write, 80); return; }
      if ((t = e.target.closest('[data-mt-bb-tile]'))) {
        if (t.classList.contains('mt-filled')) delete state.picks[parseInt(t.getAttribute('data-mt-bb-tile'), 10)];
        setTimeout(write, 80); return;
      }
      if ((t = e.target.closest('[data-mt-bb-select], [data-mt-bb-sheet-add], [data-mt-bb-open]'))) {
        if (t.hasAttribute('data-mt-bb-open') && window.matchMedia(PHONE).matches) return;
        var pid = t.getAttribute('data-mt-bb-select') || t.getAttribute('data-mt-bb-open') || t.getAttribute('data-pid');
        var idx = stepIndex(section);
        if (pid && idx > -1) {
          var sz = byData('data-mt-bb-size', pid, null, true), cl = byData('data-mt-bb-color', pid, null, true);
          state.picks[idx] = { pid: pid, size: sz ? sz.getAttribute('data-mt-bb-size') : null, color: cl ? cl.getAttribute('data-mt-bb-color') : null };
        }
        setTimeout(write, 80); return;
      }
      if ((t = e.target.closest('[data-mt-bb-add]'))) {
        if (!t.disabled && store()) { state.picks = {}; try { store().removeItem(KEY); } catch (e2) {} }
        return;
      }
      if (e.target.closest('[data-mt-bb-skip], [data-mt-bb-go]')) setTimeout(write, 120);
    }, true);

    function restore() {
      var raw = null;
      try { raw = JSON.parse(store().getItem(KEY) || 'null'); } catch (e) {}
      if (!raw || !raw.picks) return;
      restoring = true;
      try {
        var g = section.querySelector('[data-mt-bb-gender].mt-on');
        if (raw.gender && (!g || g.getAttribute('data-mt-bb-gender') !== raw.gender)) {
          var tab = byData('data-mt-bb-gender', null, raw.gender, false);
          if (tab) tab.click();
        }
        var steps = section.querySelectorAll('[data-mt-bb-go]').length;
        for (var i = 0; i < steps; i++) {
          var pk = raw.picks[i];
          if (!pk) continue;
          var go = byData('data-mt-bb-go', null, i, false);
          if (go) go.click();
          if (pk.color) { var sw = byData('data-mt-bb-color', pk.pid, pk.color, false); if (sw) sw.click(); }
          if (pk.size) {
            var chip = byData('data-mt-bb-size', pk.pid, pk.size, false);
            if (!chip || chip.disabled) continue;
            chip.click();
          }
          var btn = byData('data-mt-bb-select', null, pk.pid, false);
          if (!btn) continue;
          btn.click();
          state.picks[i] = pk;
        }
        skipped = raw.skipped || {};
        var back = byData('data-mt-bb-go', null, Math.min(raw.step || 0, steps - 1), false);
        if (back) back.click();
        markSkipped(section);
      } finally { restoring = false; }
      write();
    }
    if (!store()) return;
    var tries = 0, wait = setInterval(function () {
      if (section.querySelector('[data-mt-bb-go]')) { clearInterval(wait); restore(); }
      else if (++tries > 50) clearInterval(wait);
    }, 100);
  }
  function init() {
    var section = document.querySelector('[data-mt-bundle-builder]');
    if (!section) return;
    lastStepWatch(section);
    phoneBar(section);
    deskFrame(section);
    persist(section);
    if (wrap()) return;
    var n = 0, t = setInterval(function () { if (wrap() || ++n > 40) clearInterval(t); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();